import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description: string;
  keywords?: string;
}

function upsert(name: string, content: string, attr: "name" | "property") {
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function usePageMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    upsert("description", description, "name");
    if (keywords) upsert("keywords", keywords, "name");
    upsert("og:title", title, "property");
    upsert("og:description", description, "property");
  }, [title, description, keywords]);
}